/////////////////////////////////////////////////
// Manages all apps Images and lazyloading instances
// Using https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
////////////////////////////////////////////////////////////
(() => {
    class Images {
        constructor() {
            /* Variables */
            this.lazyLoading = {
                selectors:   [
                    'img[data-src]',                    // this loads img elements
                    '.background-autoload[data-src]',   // this loads background on div elements
                    '[data-mask-image]',                // this loads background on icons
                ],
            };

            /* Lets update instance with first load and register it in the app */
            App.ready(() => App.load(() => this.update()));
            this.bind();
        }

        get items() {
            return document.querySelectorAll(this.lazyLoading.selectors.join(', '));
        }

        refreshImage(element) {
            const src      = element.dataset.src;
            const observer = new IntersectionObserver(([e], o) => {
                if (e.intersectionRatio) {
                    e.target.setAttribute('src', src);
                    o.unobserve(e.target);
                }
            });
            observer.observe(element);
            element.removeAttribute('data-src');
        }

        refreshContainer(element) {
            const src      = element.dataset.src;
            const observer = new IntersectionObserver(([e], o) => {
                if (e.intersectionRatio) {
                    e.target.style.backgroundImage = 'url("' + src + '")';
                    o.unobserve(e.target);
                }
            });
            observer.observe(element);
            element.removeAttribute('data-src');
        }

        refreshIcon(element) {
            const src      = element.dataset.maskImage;
            const observer = new IntersectionObserver(([e], o) => {
                if (e.intersectionRatio) {
                    e.target.style.setProperty('--mask-image', src);
                    o.unobserve(e.target);
                }
            });
            observer.observe(element);
            element.removeAttribute('data-mask-image');
        }

        getFormatPath(file, format, string = 'default') {
            if (file) {
                if (file.match(/\bhttps?:\/\/\S+/gi)) {
                    const url = file.match(/\bhttps?:\/\/(.[^/]+)/);
                    const domain = url[0];
                    const path = file.replace(domain, '');

                    return domain + path.replace(string, format);
                } else {
                    return file.replace(string, format);
                }
            } else {
                return null;
            }
        }

        /* Bind all needed resources */
        bind() {
            // Tabs do not Apply as :visible so they need this help
            $('.nav-tabs > li').click(() => setTimeout(() => this.update(), 250));
            // helps when position of images has change because of resize
            $(window).resize(() => this.update());
        }

        update() {
            setTimeout(() => {
                this.items.forEach(element => {
                    // only register lazyloading to visible elements
                    if (element.tagName === 'IMG')
                        this.refreshImage(element);
                    if (element.classList.contains('background-autoload'))
                        this.refreshContainer(element);
                    if (element.classList.contains('icon-mask'))
                        this.refreshIcon(element);
                });
            }, App.Layout.settings.refresh.time + 1);
        }
    }
    App.Interface.Images = new Images();
})();
